// frontend/src/App.js
// Purpose: Serve as the main container component for the DART application
// Desired outcome: Create a root component that sets up the application layout with navigation between Upload and Analysis pages

// Import dependencies
import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppRoutes from './routes/AppRoutes';
import { fetchUploadedFiles } from './state/analysis/analysisSlice';
import logger from './utils/logger';
import Navigation from './components/Navigation/Navigation';
import './App.css';

// Main application component
function App() {
  const dispatch = useDispatch();
  
  // Initial data loading effect
  useEffect(() => {
    logger.info('App initialized');
    
    // Fetch uploaded files on application start
    dispatch(fetchUploadedFiles())
      .unwrap()
      .then(() => {
        logger.info('Successfully loaded uploaded files');
      })
      .catch((error) => {
        logger.error('Failed to load uploaded files', error);
      });
  }, [dispatch]);
  
  return (
    <Router>
      <div className="app">
        <header>
          <Navigation />
        </header>
        
        <main className="content">
          <AppRoutes />
        </main>
        
        <footer>
          <p>© {new Date().getFullYear()} DART - Digital Asset Review Tool</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;